var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ILoginScreenState, ILoginTypeEnum, } from "@domains/salesFeatures/Login/entities/iLogin";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
var LoginPresenter = /** @class */ (function () {
    function LoginPresenter(actions, usecase) {
        this.actions = actions;
        this.usecase = usecase;
        this.getIsRMPartnerFRM = function () {
            var loginTypeObj = {
                isRM: false,
                isPartner: false,
                isFRM: false,
            };
            if (!!localStorage.getItem(ELocalStorageKeys.LoginType)) {
                switch (localStorage.getItem(ELocalStorageKeys.LoginType)) {
                    case ILoginTypeEnum.FRM:
                        loginTypeObj.isFRM = true;
                        break;
                    case ILoginTypeEnum.PARTNER:
                        loginTypeObj.isPartner = true;
                        break;
                    case ILoginTypeEnum.RM:
                        loginTypeObj.isRM = true;
                        break;
                }
            }
            return loginTypeObj;
        };
    }
    LoginPresenter.prototype.resendOTP = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.resendOTP.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.forgotLoginId = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.forgotLoginId.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.redirectionToFPDUrl = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.fpdURLRedirectionURL.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    LoginPresenter.prototype.logoutUser = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.logout.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.validateChangePassword = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateChangePassword.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.validateForgotPassword = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateForgotPassword.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.userUnblock = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.userUnblock.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.userUnblockCheck = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.userUnblockCheck.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.changePassword = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.changePassword.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.resetPassword = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.resetPassword.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.forgotPassword = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.forgotPassword.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.clearLoginToken = function () {
        var loginData = {
            cipToken: "",
        };
        this.actions.getLoginData(loginData, "LoginReducer");
    };
    LoginPresenter.prototype.getLoginData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var loginCIPResponse;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loginCIPResponse = {
                            loginResponse: false,
                            loginError: null,
                        };
                        this.actions.hideError("LoginReducer");
                        this.actions.loader("LoginReducer");
                        return [4 /*yield*/, this.usecase.loginUseCase.execute({
                                onSuccess: function (data) {
                                    if (data.cipToken) {
                                        loginCIPResponse.loginResponse = true;
                                        localStorage.setItem(ELocalStorageKeys.AccessToken, data.cipToken);
                                        _this.actions.getLoginData(data, "LoginReducer");
                                    }
                                    _this.actions.stopLoader("LoginReducer");
                                },
                                onError: function (error) {
                                    loginCIPResponse.loginResponse = false;
                                    loginCIPResponse.loginError = error;
                                    _this.actions.setError({ isOpen: true, error: error }, "LoginReducer");
                                    _this.actions.stopLoader("LoginReducer");
                                },
                            }, req)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve(loginCIPResponse)];
                }
            });
        });
    };
    LoginPresenter.prototype.getLogingFeatureData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var loginResponse;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loginResponse = false;
                        this.actions.hideError("LoginReducer");
                        this.actions.loader("LoginReducer");
                        return [4 /*yield*/, this.usecase.newLoginUseCase.execute({
                                onSuccess: function (data) {
                                    if (data) {
                                        if (data === null || data === void 0 ? void 0 : data.partnercategory) {
                                            localStorage.setItem(ELocalStorageKeys.PartnerCategory, data === null || data === void 0 ? void 0 : data.partnercategory);
                                        }
                                        if (data.isOtpEnabled) {
                                            var casAdvisoryValue = (data === null || data === void 0 ? void 0 : data.isCasAccess) !== null &&
                                                (data === null || data === void 0 ? void 0 : data.isCasAccess) !== undefined &&
                                                (data === null || data === void 0 ? void 0 : data.isCasAccess) === true
                                                ? "true"
                                                : "false";
                                            var localValue = window.btoa(casAdvisoryValue);
                                            localStorage.setItem(ELocalStorageKeys.CadCam, localValue);
                                            localStorage.setItem(ELocalStorageKeys.LoginType, data.loginType);
                                            localStorage.setItem(ELocalStorageKeys.IsRHAbove, data.isRH_above);
                                            _this.actions.getLoginData({
                                                isOtpEnabled: data.isOtpEnabled,
                                                tokenId: data.tokenId,
                                                screenState: ILoginScreenState.OTP_SCREEN,
                                                hashStrUser: data.hashStrUser,
                                            }, "LoginReducer");
                                        }
                                        else {
                                            loginResponse = true;
                                            // data.loginType = ILoginTypeEnum.FRM;
                                            var casAdvisoryValue = (data === null || data === void 0 ? void 0 : data.isCasAccess) !== null &&
                                                (data === null || data === void 0 ? void 0 : data.isCasAccess) !== undefined &&
                                                (data === null || data === void 0 ? void 0 : data.isCasAccess) === true
                                                ? "true"
                                                : "false";
                                            var localValue = window.btoa(casAdvisoryValue);
                                            localStorage.setItem(ELocalStorageKeys.CadCam, localValue);
                                            localStorage.setItem(ELocalStorageKeys.LoginType, data.loginType);
                                            localStorage.setItem(ELocalStorageKeys.AccessToken, data.cipToken);
                                            localStorage.setItem(ELocalStorageKeys.IsRHAbove, data.isRH_above);
                                            // localStorage.setItem("loginType", ILoginTypeEnum.FRM);
                                            _this.actions.getLoginData(__assign(__assign({}, data), { isOtpEnabled: false, screenState: ILoginScreenState.SUCCESS }), "LoginReducer");
                                        }
                                    }
                                    _this.actions.stopLoader("LoginReducer");
                                },
                                onError: function (error) {
                                    loginResponse = false;
                                    _this.actions.setError({ isOpen: true, error: error }, "LoginReducer");
                                    _this.actions.stopLoader("LoginReducer");
                                },
                            }, req)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve(loginResponse)];
                }
            });
        });
    };
    LoginPresenter.prototype.getValidateOTPData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var loginResponse;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loginResponse = false;
                        this.actions.hideError("LoginReducer");
                        this.actions.loader("LoginReducer");
                        return [4 /*yield*/, this.usecase.otpValidation.execute({
                                onSuccess: function (data) {
                                    if (data) {
                                        if (data.cipToken) {
                                            loginResponse = true;
                                            var casAdvisoryValue = (data === null || data === void 0 ? void 0 : data.isCasAccess) !== null &&
                                                (data === null || data === void 0 ? void 0 : data.isCasAccess) !== undefined &&
                                                (data === null || data === void 0 ? void 0 : data.isCasAccess) === true
                                                ? "true"
                                                : "false";
                                            var localValue = window.btoa(casAdvisoryValue);
                                            localStorage.setItem(ELocalStorageKeys.CadCam, localValue);
                                            localStorage.setItem(ELocalStorageKeys.LoginType, data.loginType);
                                            localStorage.setItem(ELocalStorageKeys.AccessToken, data.cipToken);
                                            localStorage.setItem(ELocalStorageKeys.IsRHAbove, data.isRH_above);
                                            _this.actions.getLoginData(__assign(__assign({}, data), { isOtpEnabled: false, screenState: ILoginScreenState.SUCCESS }), "LoginReducer");
                                        }
                                    }
                                    _this.actions.stopLoader("LoginReducer");
                                },
                                onError: function (error) {
                                    loginResponse = false;
                                    _this.actions.setError({ isOpen: true, error: error }, "LoginReducer");
                                    _this.actions.stopLoader("LoginReducer");
                                },
                            }, req)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve(loginResponse)];
                }
            });
        });
    };
    LoginPresenter.prototype.changeCurrentLoginComponent = function (req) {
        this.actions.changeLoginComponent({ currentComponent: req.currentComponent, extraConfig: req.extraConfig }, "LoginComponentReducer");
    };
    LoginPresenter.prototype.validateSingleSignOn = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateSingleSignOn.execute({
                onSuccess: function (data) {
                    var _a, _b, _c, _d;
                    localStorage.removeItem(ELocalStorageKeys.LoginType);
                    localStorage.removeItem(ELocalStorageKeys.AccessToken);
                    localStorage.removeItem(ELocalStorageKeys.IsRHAbove);
                    localStorage.removeItem(ELocalStorageKeys.PartnerCategory);
                    localStorage.setItem(ELocalStorageKeys.LoginType, (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.empType);
                    localStorage.setItem(ELocalStorageKeys.AccessToken, (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.jwtToken);
                    localStorage.setItem(ELocalStorageKeys.IsRHAbove, (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.isRH_above);
                    localStorage.setItem(ELocalStorageKeys.PartnerCategory, (_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.partnercategory);
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.validateForgotLoginId = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.validateForgotLoginID.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.getGuidToken = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getGuidToken.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginPresenter.prototype.getSSOLoginData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var loginResponse;
            var _this = this;
            return __generator(this, function (_a) {
                loginResponse = false;
                this.actions.hideError("LoginReducer");
                this.actions.loader("LoginReducer");
                localStorage.removeItem("loginType");
                localStorage.removeItem("access_token");
                localStorage.removeItem("isRH_above");
                localStorage.removeItem("partnerCategory");
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.getSSOLoginData.execute({
                            onSuccess: function (data) {
                                if (data) {
                                    loginResponse = true;
                                    var casAdvisoryValue = (data === null || data === void 0 ? void 0 : data.isCasAccess) !== null &&
                                        (data === null || data === void 0 ? void 0 : data.isCasAccess) !== undefined &&
                                        (data === null || data === void 0 ? void 0 : data.isCasAccess) === true
                                        ? "true"
                                        : "false";
                                    var localValue = window.btoa(casAdvisoryValue);
                                    localStorage.setItem("cadCam", localValue);
                                    localStorage.setItem("loginType", data.loginType);
                                    localStorage.setItem("access_token", data.cipToken);
                                    localStorage.setItem("isRH_above", data.isRH_above);
                                    _this.actions.getLoginData(__assign(__assign({}, data), { isOtpEnabled: false, screenState: ILoginScreenState.SUCCESS }), "LoginReducer");
                                }
                                resolve(data);
                                _this.actions.stopLoader("LoginReducer");
                            },
                            onError: function (error) {
                                reject(error);
                                loginResponse = false;
                                _this.actions.setError({ isOpen: true, error: error }, "LoginReducer");
                                _this.actions.stopLoader("LoginReducer");
                            },
                        }, req);
                    })];
            });
        });
    };
    return LoginPresenter;
}());
export default LoginPresenter;
